// Theme configuration for different parts of the application
export const themeConfig = {
  // Public pages theme (login, welcome, etc)
  public: {
    default: 'light' as const,
    // Can be extended with brand colors, fonts, etc
    colors: {
      primary: 'blue',
      secondary: 'gray',
    },
  },

  // User theme options
  userOptions: ['light', 'dark', 'system'] as const,

  // Default user theme when account is created
  defaultUserTheme: 'system' as const,
} as const;

export type Theme = 'light' | 'dark' | 'system';
export type UserTheme = (typeof themeConfig.userOptions)[number];
